<div class="card h-100" [title]="description"><div class="card-body d-flex flex-column justify-content-center overflow-hidden">
  <h4 class="subheader mb-1 text-truncate" [title]="label">@if (iconSvg) { <app-dashboard-icon [svg]="iconSvg" class="me-2"></app-dashboard-icon> } {{ label }}</h4>
  <span class="h3 m-0 metric-value">{{ displayed }}</span>
</div></div>
